import Vue from 'vue';
import App from './App.vue';
import router from './router';
import http from './utils/http';
import libs from './libs';
Vue.config.productionTip = false;
Vue.prototype.$http = http;
Vue.prototype.httpRequest = http;
Vue.use(libs);
Vue.use(window.AVUE);

//如果使用字典需要赋值axios为全局
import axios from 'axios';
Vue.prototype.$axios = axios;

import 'vant/lib/index.less';

import 'amfe-flexible';
import {
  Button,
  Uploader,
  PullRefresh,
  Collapse,
  CollapseItem,
  ImagePreview,
  Skeleton,
  Tabbar,
  TabbarItem,
  Field,
  Grid,
  GridItem,
  Lazyload,
  swipe,
  swipeItem,
  IndexBar,
  IndexAnchor,
  Cell,
  Overlay,
  List,
  sticky,
  CellGroup,
  Search,
  Icon,
  Image,
  Tag,
  Empty,
  Panel,
  Picker,
  Radio,
  RadioGroup,
  Card,
  Tab,
  Tabs,
  Col,
  Row,
  Sidebar,
  SidebarItem,
  SwipeCell,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Form,
  ActionSheet,
  Popup,
  Notify,
  NavBar
} from 'vant';
import { getToken } from './utils/auth';
let comps = [
  Button,
  Uploader,
  PullRefresh,
  Collapse,
  CollapseItem,
  ImagePreview,
  Skeleton,
  Tabbar,
  TabbarItem,
  Field,
  Grid,
  GridItem,
  Lazyload,
  swipe,
  swipeItem,
  IndexBar,
  IndexAnchor,
  Cell,
  Overlay,
  List,
  sticky,
  CellGroup,
  Search,
  Icon,
  Image,
  Tag,
  Card,
  Empty,
  Panel,
  Picker,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  Col,
  Row,
  Sidebar,
  SidebarItem,
  SwipeCell,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Form,
  ActionSheet,
  Popup,
  Notify,
  NavBar
];
for (let comp of comps) {
  Vue.use(comp);
}
router.beforeEach((to, from, next) => {
  console.log('test main:{}', to);
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.query.token) {
    const tempToken = window.localStorage.getItem('token');
    if (tempToken !== to.query.token) {
      window.localStorage.clear();
    }
    window.localStorage.setItem('token', to.query.token);
  }
  if (to.query.code) {
    window.localStorage.setItem('code', to.query.code);
  }
  if (to.query.roleName === 'null' || !to.query.roleName) {
    let user = window.localStorage.getItem('user');
    if (user) {
      user = JSON.parse(user);
      window.localStorage.setItem('roleName', user.role_name);
    }
  } else {
    window.localStorage.setItem('roleName', to.query.roleName);
  }

  if (to.path === '/wechat' || to.path === '/wechat/' || to.path === Vue.publicPath) {
    if (to.path === '/wechat/shareMe') {
      next();
    } else if (to.query.token) {
      next();
    } else {
      next({
        path: '/wechat/home'
      });
    }
    return;
  }
  if (to.path === '/wechat/login' && getToken() && getToken() !== 'undefined') {
    next({
      path: '/wechat/home'
    });
    return;
  }
  if (to.meta.requireAuth) {
    if (!getToken()) {
      next({
        path: '/wechat/login',
        query: {
          redirect: to.name,
          ...to.query
        }
      });
    } else {
      next();
    }
  } else {
    console.log('main 3333');
    next();
  }
});
new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
